import axios from 'axios';
import Wix from 'Wix'
import { detectBrowser } from './utils';

Wix.Utils.getInstance = function () {
    var url = window.location;
    var instanceRegexp = /.*instance=([\[\]a-zA-Z0-9\.\-_]*?)(&|$|#).*/g;
    var instance = instanceRegexp.exec(url);
    if (instance && instance[1]) {
        return instance[1];
    } else {
        return undefined;
    }
};


const pojemnikUrl = "https://pojemnik.light-tech.online";
const USER_LS_DATA_NAME = "ts-user-poj-data";
const TKN = Wix.Utils.getInstance();
const head = {
    headers: {
        Authorization: TKN
    }
}

function exceptionInterceptor(dangerousFunction) {
    try {
        if (typeof dangerousFunction === "function") {
            dangerousFunction();
        };
    } catch (e) {
        console.log(e)
    };
}


export const pojemnikApi = {
    handleOpenSettings(premium, appName) {
        exceptionInterceptor(() => {
            const body = {
                appName,
                instanceId: Wix.Utils.getInstanceId(),
                compId: Wix.Utils.getOrigCompId(),
                locale: Wix.Utils.getLocale(),
                siteOwnerId: Wix.Utils.getSiteOwnerId(),
                premium
            }

            let llUserData = localStorage.getItem(USER_LS_DATA_NAME);
            let needSend = false;

            if (llUserData === null) {
                needSend = true;
                localStorage.setItem(USER_LS_DATA_NAME, JSON.stringify(body));
            } else {
                if (JSON.parse(llUserData).premium !== body.premium) {
                    needSend = true;
                    localStorage.removeItem(USER_LS_DATA_NAME);
                    localStorage.setItem(USER_LS_DATA_NAME, JSON.stringify(body))
                }
            }

            if (needSend)
                axios.post(`${pojemnikUrl}/action/settingsOpen`, body, head)
        })
    },

    rememberUsedBrowser(appName) {
        exceptionInterceptor(() => {
            const viewMode = Wix.Utils.getViewMode();
            
            if (viewMode === 'editor') {
                let browserName = detectBrowser();
                const CASHED_BROWSER_DATA_NAME = `${appName}-browser`;
                const cashedBrowser = JSON.parse(localStorage.getItem(CASHED_BROWSER_DATA_NAME));
                let needSendData = false;

                if (!cashedBrowser)
                    needSendData = true;
                else if (cashedBrowser !== browserName)
                    needSendData = true;

                if (needSendData) {
                    const body = {
                        appName: appName,
                        siteOwnerId: Wix.Utils.getSiteOwnerId(),
                        browserName: browserName
                    };
                    axios.post(`${pojemnikUrl}/action/browser/updateUsage`, body, head);

                    localStorage.setItem(CASHED_BROWSER_DATA_NAME, JSON.stringify(browserName))
                }
            }
        })
    },

    // handleQuizForm(body) {
    //     exceptionInterceptor(() => {
    //         axios.post(`${pojemnikUrl}/action/usersIssue`, body, head)
    //     })
    // },

    handleDeleteComponent(premium, appName) {
        exceptionInterceptor(() => {
            const body = {
                appName,
                instanceId: Wix.Utils.getInstanceId(),
                compId: Wix.Utils.getCompId(),
                locale: Wix.Utils.getLocale(),
                premium
            }
            axios.post(`${pojemnikUrl}/action/customers/delete`, body, head)

        })
    },

    handleNotificationOpen(appName, notificationName) {
        exceptionInterceptor(() => {
            axios.post(`${pojemnikUrl}/action/notificationOpened?appName=${appName}&notificationName=${notificationName}`, {}, head)
        })
    },

    handleNotificationUsed(appName, notificationName) {
        exceptionInterceptor(() => {
            axios.post(`${pojemnikUrl}/action/notificationUsed?appName=${appName}&notificationName=${notificationName}`, {}, head)
        })
    },


    handleSaleViewed(appName, saleName) {
        exceptionInterceptor(() => {
            const body = {
                saleName: saleName,
                siteOwnerId: Wix.Utils.getSiteOwnerId(),
                appName: appName,
            }

            axios.post(`${pojemnikUrl}/action/sale/view`, body, head)
        })
    },

    handleSaleUsed(appName, saleName) {
        exceptionInterceptor(() => {
            const body = {
                saleName: saleName,
                siteOwnerId: Wix.Utils.getSiteOwnerId(),
                appName: appName,
            }

            axios.post(`${pojemnikUrl}/action/sale/use`, body, head)
        })
    },

    reportAppToAppTransitionsViewed(appNameFrom, appNameTo) {
        exceptionInterceptor(() => {

            axios.post(
                `${pojemnikUrl}/action/transitionBetweenApps/updateLinkViewed?appNameFrom=${appNameFrom}&appNameTo=${appNameTo}`,
                {},
                head
            )
        })
    },

    reportAppToAppTransitionsRedirected(appNameFrom, appNameTo) {
        exceptionInterceptor(() => {
            axios.post(
                `${pojemnikUrl}/action/transitionBetweenApps/updateRedirected?appNameFrom=${appNameFrom}&appNameTo=${appNameTo}`,
                {},
                head
            )
        })
    },

    handleTemplateInteraction(appName, {templateName, interactionType}){
        exceptionInterceptor(()=>{
            // console.log();
            axios.post(
                `${pojemnikUrl}/action/template/update`,
                {appName, name: templateName, type: interactionType},
                head
            )
        })
    }
}